import React from 'react';
import {Redirect} from 'react-router-dom';

import Unauthenticated from 'Components/Layouts/Unauthenticated';
import AuthLayout from 'Components/Layouts/AuthLayout';
import {FormHandler, Input} from 'Components/Form';

import SiteHardPasswordApi from 'Services/Api/Base/SiteHardPassword';

import {SiteHardPassword as SiteHardPasswordEvent} from 'Services';

class SiteHardPassword extends React.Component {
    /**
     * @var state
     */
    state = {
        redirect: null
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        if (SiteHardPasswordEvent.authed) {
            this.setState({
                redirect: '/'
            });
        }
    }

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {redirect} = this.state;
        const {form, handleInput, handleSubmit, working, alert} = this.props;

        if (redirect) {
            return <Redirect to={redirect} />;
        }

        return (
            <Unauthenticated>
                <AuthLayout
                    title="Welcome to the Whitbread Supplier Conference Registration Site"
                    submitText="Enter"
                    onSubmit={(e) => handleSubmit(e, SiteHardPasswordApi.login)}
                    working={working}
                    alert={alert}
                >
                    <Input
                        label="Please enter the password contained within your invitation email"
                        value={form.password}
                        onChange={v => handleInput('password', v)}
                    />
                </AuthLayout>
            </Unauthenticated>
        );
    }
}

export default FormHandler(SiteHardPassword);